import patternValidators, { emailFieldError } from 'helpers/validators/pattern-validators';
import { useWatch } from 'react-hook-form';

import BrandingTabSplitLayout from 'components/BrandingTabSplitLayout/BrandingTabSplitLayout';
import { Input, InputGroup, Textarea, ToggleLabel } from 'components/FormComponents';

export const LeadGeneration = ({
  register,
  readOnly = false,
  backgroundColor = 'background-secondary',
  brand,
  control,
  errors,
}) => {
  const followUpQuestionActiveValue = useWatch({ control, name: 'follow_up_question_active' });
  const engagementEmailNotificationValue = useWatch({
    control,
    name: 'custom_engagement_email_active',
  });

  return (
    <BrandingTabSplitLayout key={brand?.id} shellClassName={backgroundColor}>
      <div className="flex flex-col gap-8">
        <section className="rounded-3xl border border-neutral-4 bg-white p-6 shadow-sm flex flex-col gap-2">
          <InputGroup noMargin>
            <ToggleLabel
              register={register}
              name="follow_up_question_active"
              label="Follow Up Yes/No Question"
            />
          </InputGroup>
          <InputGroup noMargin disabled={!followUpQuestionActiveValue}>
            <Textarea
              name="follow_up_question"
              register={register}
              placeholder="Would you be inerested in hearing about new opportunities?"
              inputProps={{ rows: 3 }}
              validators={
                followUpQuestionActiveValue
                  ? {
                      required:
                        'You have enabled the follow up question, please add a question to continue.',
                    }
                  : {}
              }
              error={followUpQuestionActiveValue ? errors.follow_up_question?.message : ''}
            />
          </InputGroup>
        </section>
        <section className="rounded-3xl border border-neutral-4 bg-white p-6 shadow-sm">
          <InputGroup noMargin>
            <ToggleLabel
              register={register}
              name="custom_engagement_email_active"
              label="Email address notification"
            />
          </InputGroup>
          <InputGroup disabled={!engagementEmailNotificationValue} noMargin>
            <Input
              register={register}
              name="engagement_email"
              placeholder="e.g. brad@checkmate.tech"
              validators={
                engagementEmailNotificationValue
                  ? {
                      required:
                        'You have enabled the email address notification, please add an email address to continue.',
                      ...patternValidators.email,
                    }
                  : {}
              }
              error={
                engagementEmailNotificationValue ? emailFieldError(errors.engagement_email) : ''
              }
            />
          </InputGroup>
        </section>
      </div>
    </BrandingTabSplitLayout>
  );
};
